import {Component, Input} from '@angular/core';
import {ConfigStub} from "../../_typing/config-stub";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";

@Component({
    selector: 'input-data-sheet-form',
    imports: [
        SelectSearchComponentComponent,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption
    ],
    templateUrl: 'input-data-sheet-form.component.html'
})
export class InputDataSheetFormComponent {
    private _config: any;
    @Input()
    set config(config) {
        this._config = config;
    }

    get config() {
        return this._config;
    }

    hint: string = '';

    constructor() {
    }

    processChange(event) {
        if (!event) return;
        this.config.process = new ConfigStub(event.value)
    }
}
